import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import App from './App';
import i18n from '../../i18n';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});

export default function AppWrapper(props) {
    return (
        <QueryClientProvider client={queryClient}>
            <App history={props.history} />
            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    );
}
